import { FormattedMessage } from 'react-intl'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { getCurrentSpaceId } from '@/components/App/selectors'
import Button from '@/components/Button'
import { Plus } from '@/components/Icons'
import Page from '@/components/Page'
import { changeCurrentSpace as changeCurrentSpaceAction } from '@/store/actions'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { getSpaces } from '@/store/selectors'
import clientLocalStorage from '@/utilities/clientLocalStorage'

import { deleteSpace as deleteSpaceAction } from './actions'
import messages from './messages'
import OrganizationSpaces from './OrganizationSpaces'

const StyledPlus = styled(Plus)`
  margin-right: 5px;
`

function OrganizationSpacesPage() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useAppDispatch()

  const spaces = useAppSelector(getSpaces)
  const currentSpaceId = useAppSelector(getCurrentSpaceId)

  const navigateToAddSpace = () => {
    history.push(location.pathname + '/create')
  }

  const navigateToEditSpace = (spaceId: any) => {
    history.push(location.pathname + '/' + spaceId)
  }

  const onDeleteSpace = async (spaceId: any) => {
    try {
      await dispatch(deleteSpaceAction(spaceId))

      const localStorageSpace = clientLocalStorage.getItem('selectedSpace')
      if (spaceId === localStorageSpace) {
        clientLocalStorage.removeItem('selectedSpace')
      }

      if (spaceId === currentSpaceId) {
        const filteredSpaces = spaces.filter(s => s.id !== spaceId)
        const defaultSpaceId =
          filteredSpaces.length > 0 ? filteredSpaces.find(s => s.default)?.id || filteredSpaces[0].id : null

        if (defaultSpaceId !== null) {
          clientLocalStorage.setItem('selectedSpace', defaultSpaceId)
        }
        return dispatch(changeCurrentSpaceAction(defaultSpaceId!))
      }
    } catch {}
  }

  return (
    <Page>
      <Page.Header
        title={<FormattedMessage {...messages.title} />}
        buttons={
          <Button color="primary" onClick={navigateToAddSpace} className="button--primary">
            <StyledPlus />
            <FormattedMessage {...messages.createSpace} />
          </Button>
        }
      />
      <OrganizationSpaces spaces={spaces} navigateToEditSpace={navigateToEditSpace} onDeleteSpace={onDeleteSpace} />
    </Page>
  )
}

OrganizationSpacesPage.displayName = 'OrganizationSpacesPage'

export default OrganizationSpacesPage
